import service from "../services/service";

// Feature gated until Paddle webhook fulfillment is connected to Hostor.
// Deliberately separate from the existing Helcim checkout flow.
let paddlePromise;
let initialized = false;
async function loadPaddleScript() {
  if (window.Paddle) return window.Paddle;
  if (!paddlePromise) {
    paddlePromise = new Promise((resolve, reject) => {
      const tag = document.createElement("script");
      tag.src = "https://cdn.paddle.com/paddle/v2/paddle.js";
      tag.onload = () => window.Paddle ? resolve(window.Paddle) : reject(new Error("Paddle did not initialize"));
      tag.onerror = () => reject(new Error("Unable to load Paddle.js"));
      document.head.appendChild(tag);
    });
  }
  return paddlePromise;
}

export async function getPaddleSandboxConfig() {
  const response = await service.get("/billing/paddle-sandbox/config");
  // Existing Hostor service may envelope server responses in {success, data}.
  const body = response?.data?.data || response?.data || response;
  if (!["sandbox", "production"].includes(body?.environment)) throw new Error("Paddle is not configured");
  return body;
}

export async function initializePaddleSandbox() {
  const config = await getPaddleSandboxConfig();
  const paddle = await loadPaddleScript();
  if (config.environment === "sandbox") paddle.Environment.set("sandbox");
  if (!initialized) {
    paddle.Initialize({ token: config.clientToken, eventCallback: (event) => window.__hostorPaddleEvent?.(event), checkout: { settings: { displayMode: "overlay", variant: "one-page" } } });
    initialized = true;
  }
  return { paddle, config };
}

export async function previewPaddleSandboxPrice(plan, interval) {
  const { paddle, config } = await initializePaddleSandbox();
  const priceId = config.prices?.[plan]?.[interval];
  if (!priceId) throw new Error("Missing Paddle price for " + plan + "/" + interval);
  return paddle.PricePreview({ items: [{ priceId, quantity: 1 }] });
}


export async function openPaddleSandboxCheckout(checkout, onEvent) {
  if (!checkout?.transactionId) throw new Error("Paddle transaction is missing");
  const { paddle } = await initializePaddleSandbox();
  window.__hostorPaddleEvent = onEvent;
  paddle.Checkout.open({
    transactionId: checkout.transactionId,
    settings: { displayMode: "overlay", variant: "one-page" }
  });
  return () => {
    window.__hostorPaddleEvent = null;
    paddle.Checkout.close();
  };
}
